import {observer} from "mobx-react";
import {DialogStore, fmsPackageDetailStore} from "../../../store";
import {ModalDialog} from "../../ui";

interface FmsModalDialogCancelDocumentProps {
    store: DialogStore
}

const FmsModalDialogCancelDocument = observer(function FmsModalDialogCancelDocument({
    store
                                                                                }: FmsModalDialogCancelDocumentProps) {
    const cancelDocumentDialog = store
    return <ModalDialog
        store={cancelDocumentDialog}
        actions={[
            {
                label: "Abbrechen",
                execute: async function () {
                    fmsPackageDetailStore.selectedItem = undefined
                    cancelDocumentDialog.dialogOpen = false
                },
                className: 'is-primary is-rounded is-small'
            },
            {
                label: "Dokument stornieren",
                execute: async function () {
                    cancelDocumentDialog.executing = true
                    await fmsPackageDetailStore.markSelectedItemAsCancelled()
                    fmsPackageDetailStore.selectedItem = undefined
                    cancelDocumentDialog.executing = false
                    cancelDocumentDialog.dialogOpen = false
                },
                className: 'is-rounded is-small'
            }
        ]}
        title={"Dokument stornieren?"}
    >
        Sind Sie sich sicher, dass Sie dieses Dokument stornieren wollen?
    </ModalDialog>
})

export {
    FmsModalDialogCancelDocument
}
